import React from "react";
import Container from "react-bootstrap/Container"
import Login2 from '../views/Login2'
import Home_campo_secciones from '../views/Home_campo_secciones'
import firebaseApp from "../firebase/credenciales";
import { getAuth, onAuthStateChanged, sendPasswordResetEmail } from "firebase/auth";
const auth = getAuth(firebaseApp);



function CRUD_campo_secciones(){

    

    const [usuario, setUsuario] = React.useState(null);

  onAuthStateChanged(auth, (usuarioFirebase) => {
    if (usuarioFirebase) {
      setUsuario(usuarioFirebase);
    } else {
      setUsuario(null);
    }
  });
    return(
    <div>
      {usuario ? <Home_campo_secciones usuario={usuario}></Home_campo_secciones>: <Login2 />}
   </div>
    );
}




export default CRUD_campo_secciones;